import { Alert, Box, Button, Card, createTheme, CssBaseline, Grid, InputAdornment, TextField, ThemeProvider } from "@mui/material";
import Container from "@mui/material/Container";
import * as Yup from "yup";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import PhoneIphoneOutlinedIcon from "@mui/icons-material/PhoneIphoneOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AddShoppingCartOutlinedIcon from "@mui/icons-material/AddShoppingCartOutlined";
import quickPayService from "../http/quickpay.service";
import MaskField from "../components/control/mask-field";
import { useForm, useFormState } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { isDate } from "date-fns";
import { useEffect, useState } from "react";
declare const grecaptcha: any;

const theme = createTheme();
const Main: React.FC<{}> = () => {
  const [messageError, setMessageError] = useState("");
  const initForm = {
    FirstName: "",
    LastName: "",
    DOB: null,
    Email: "",
    CellPhone: "",
    Invoice: "",
    Amount: "",
    RetypeAmount: "",
    Code: "",
  };

  const parseDateString = (value: any, originalValue: any) => {
    const parsedDate = isDate(originalValue) ? originalValue : originalValue && originalValue.length > 0 ? new Date(originalValue) : null;

    return parsedDate;
  };

  const formSchema = Yup.object().shape({
    FirstName: Yup.string().max(100, "First name is too long").required("First Name is required"),
    LastName: Yup.string().max(100, "Last name is too long").required("Last Name is required"),
    DOB: Yup.date().nullable().transform(parseDateString).max(new Date(), "Invalid DOB"),
    Invoice: Yup.string().max(100, "Invoice is too long").required("Invoice Name is required"),
    Amount: Yup.number()
      .transform((value) => (isNaN(value) ? 0 : value))
      .positive("Must be greater than 0")
      .integer("Must be integer")
      .required("Please type amount")
      .min(1, "Amount must be greater than $1"),
    RetypeAmount: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .transform((value) => (isNaN(value) ? 0 : value))
      .positive("Must be greater than 0")
      .integer("Must be integer")
      .required("Please retype amount")
      .min(1, "Amount must be greater than $1")
      .test("amount-match", "Amount not match", function (value) {
        return this.parent.Amount === value;
      }),
    Email: Yup.string().nullable(true).max(255).email("Must be a valid email"),
    CellPhone: Yup.string().nullable(true),
    Code: Yup.string().nullable().required("Recaptcha is required"),
  });

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(formSchema),
    defaultValues: initForm,
  });

  const { isSubmitting } = useFormState({
    control,
  });

  const sendQuickpay = (values: any) => {
    if (values) {
      quickPayService
        .checkout({ ...values })
        .then((r) => {
          window.location.href = r;
        })
        .catch((error) => {
          const message = error.data ?? "Occured error during execute your payment.";
          setMessageError(message);
        });
    }
  };

  const onSubmit = (values: any) => {
    sendQuickpay(values);
  };

  useEffect(() => {
    setTimeout(() => {
      grecaptcha.render("example1", {
        sitekey: "6LdTWCsgAAAAAJaPfq5ZlUgnNaDHzVo-qs23tAiz",
        theme: "light",
        callback: (response: string) => {
          setValue("Code", response, { shouldValidate: true });
        },
      });
    }, 200);
  }, []);
  const onError = (errors: any, e: any) => console.log(errors, e);
  return (
    <ThemeProvider theme={theme}>
      <Container sx={{ maxWidth: "lg", pt: 4 }}>
        <Card sx={{ p: 4, borderRadius: "1rem" }}>
          <CssBaseline />
          <Box component="span" sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <a href="https://primemedteam.com">
              <img height="80px" src="https://www.primemedteam.com/wp-content/uploads/2019/08/PrimeMedicalLogo-Transaprent.png" alt="Prime Medical Group" />
            </a>
          </Box>
          <form noValidate onSubmit={handleSubmit(onSubmit, onError)}>
            <Grid container spacing={4} marginTop={4}>
              {messageError && (
                <Grid item xs={23} marginTop={2}>
                  <Alert variant="outlined" severity="warning">
                    {messageError}
                  </Alert>
                </Grid>
              )}
              <Grid item md={6} xs={12}>
                <TextField
                  variant="outlined"
                  type={"text"}
                  label="Patient First Name"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircleOutlinedIcon />
                      </InputAdornment>
                    ),
                  }}
                  error={errors && errors.FirstName ? true : false}
                  helperText={errors.FirstName?.message ?? ""}
                  {...register("FirstName")}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  variant="outlined"
                  {...register("LastName")}
                  label="Patient Last Name"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircleOutlinedIcon />
                      </InputAdornment>
                    ),
                  }}
                  error={errors && errors.LastName ? true : false}
                  helperText={errors.LastName?.message ?? ""}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  variant="outlined"
                  type="email"
                  {...register("Email")}
                  label="Contact Email"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailOutlinedIcon />
                      </InputAdornment>
                    ),
                  }}
                  error={errors && errors.Email ? true : false}
                  helperText={errors.Email?.message ?? ""}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <MaskField
                  variant="outlined"
                  type={"text"}
                  control={control}
                  name="CellPhone"
                  label="Contact Cell Phone"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PhoneIphoneOutlinedIcon />
                      </InputAdornment>
                    ),
                  }}
                  error={errors && errors.CellPhone ? true : false}
                  helperText={errors.CellPhone?.message ?? ""}
                  mask={"(000) 000-0000"}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <TextField
                  variant="outlined"
                  type={"text"}
                  {...register("Invoice")}
                  label="Invoice Number"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <ReceiptLongOutlinedIcon />
                      </InputAdornment>
                    ),
                  }}
                  error={errors && errors.Invoice ? true : false}
                  helperText={errors.Invoice?.message ?? ""}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <MaskField
                  variant="outlined"
                  control={control}
                  name="Amount"
                  label="Amount"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AttachMoneyOutlinedIcon />
                      </InputAdornment>
                    ),
                  }}
                  error={errors && errors.Amount ? true : false}
                  helperText={errors.Amount?.message ?? "Please round the payment amount to the nearest dollar."}
                  mask={Number}
                  scale={0}
                  radix={"."}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <MaskField
                  variant="outlined"
                  control={control}
                  name="RetypeAmount"
                  label="Retype Amount"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AttachMoneyOutlinedIcon />
                      </InputAdornment>
                    ),
                  }}
                  error={errors && errors.RetypeAmount ? true : false}
                  helperText={errors.RetypeAmount?.message ?? "Please round the payment amount to the nearest dollar."}
                  mask={Number}
                  scale={0}
                  radix={"."}
                />
              </Grid>
              <Grid item alignItems={"center"} flexDirection={"column"} xs={12} display="flex" justifyContent="center" marginTop={2}>
                <div id="example1" />
                {errors && errors.Code && <div style={{ display: "block", color: "#d32f2f", fontSize: "0.75rem" }}>{errors.Code.message ?? ""}</div>}
              </Grid>
              <Grid item xs={12} display="flex" justifyContent="center" marginTop={2}>
                <Button disabled={isSubmitting} type="submit" variant="contained" startIcon={<AddShoppingCartOutlinedIcon />}>
                  Pay Now
                </Button>
              </Grid>
            </Grid>
          </form>
        </Card>
      </Container>
      <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
        <Box sx={{ m: 1 }}>
          <img height="80px" src="https://umedoc-prod.s3.amazonaws.com/RandomFiles/privacy.png" alt="Privacy" />
        </Box>
        <Box sx={{ m: 1 }}>
          <img height="80px" src="https://umedoc-prod.s3.amazonaws.com/RandomFiles/hipaa.png" alt="Hipaa" />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default Main;
